// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13cjc","controls":"styles_controls__3YMJ_","charLimit":"styles_charLimit__1k7Eo","input":"styles_input__1lAR8","send":"styles_send__2vPEx"};